import PureGameElement from '../../tools/PureGameElement';
import {
    pauseWidth,
    gameWindowSize,
    pauseTopMargin,
    pauseRightMargin
}                      from '../../constants/appConstants';
import spritePause     from '../../../assets/img/spritePause.png';
import spritePlay      from '../../../assets/img/spritePlay.png';

class PauseButton extends PureGameElement {
    constructor ( scene ) {
        super( scene );
        this._sprite = null;
        this._zone = null;
    }

    get posX () {
        return gameWindowSize.width - this.width - pauseRightMargin;
    }

    get posY () {
        return pauseTopMargin;
    }

    get width () {
        return pauseWidth;
    }

    get height () {
        return this.width;
    }

    get spriteKey () {
        return this.scene.isPaused ? 'spritePlay' : 'spritePause';
    }

    preload () {
        super.preload();
        this.scene.load.image( 'spritePause', spritePause );
        this.scene.load.image( 'spritePlay', spritePlay );
    }

    create () {
        super.create();

        this._sprite = this.scene.add.image(
            this.posX,
            this.posY,
            this.spriteKey
        ).setOrigin( 0, 0 );
        this._sprite.depth = 10;
        this._sprite.setSize( this.width, this.height );
        this._sprite.setDisplaySize( this.width, this.height );

        this._zone = this.scene.add.zone(
            this.posX, this.posY,
            this.width, this.height,
        ).setOrigin( 0, 0 );
        this._zone.setInteractive();
        this._zone.on( 'pointerdown', () => {
            this.onClick();
        } );
    }

    onClick () {
        this.scene.togglePause();
        this._sprite.setTexture( this.spriteKey );
    }
}

export default PauseButton;
